import { render, staticRenderFns } from "./RuleReader.vue?vue&type=template&id=b71cb404"
import script from "./RuleReader.vue?vue&type=script&lang=js"
export * from "./RuleReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports